import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../../Core/Container';
import Link from '../../../Core/Link';
import ProductStep from '../../Cards/ProductStep';

export const StyledContainer = styled(Container)``;

export const Heading = styled.div`
  margin-bottom: 48px;

  > h1,
  > h2,
  > h3 {
    margin-bottom: 20px;
  }

  &.center-aligned,
  &.center {
    text-align: center;
  }

  > p {
    text-align: center;
  }
`;

export const Grid = styled.div`
  position: relative;
  margin: 0 auto;
  max-width: 440px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    display: flex;
    justify-content: space-around;
    display: grid;
    align-items: center;
    justify-items: center;
    max-width: 100%;
    column-gap: 24px;
    row-gap: 25px;
    grid-template-columns: repeat(3, 1fr [column]);
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    column-gap: 26px;
    row-gap: 56px;
  }
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  h2,
  h3 {
    color: ${themeGet('colors.velvet')};
    margin: 0 0 30px 0;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin-top: 50px;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    h2,
    h3 {
      margin: 0 30px 0 0;
    }
  }
`;

export const Btn = styled(Link)``;

export const StyledPhone = styled(ProductStep)`
  position: relative;
  text-align: center;
  display: flex;
  flex-direction: column;

  img,
  video {
    max-height: 554px;
    width: 100%;
    object-fit: contain;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    img,
    video {
      max-height: 526px;
    }
  }
`;

export const StepContainers = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    display: none;
  }
`;
export const CarouselControls = styled.div`
  display: block;
  padding: 2rem;

  ul {
    display: flex;
    justify-content: center;
    align-items: center;

    li {
      margin: 0 1rem;
    }

    li:not(:first-child) {
      margin-top: 0;
    }
  }
`;

export const CarouselButton = styled.button`
  width: 15px;
  height: 15px;
  border: 2px solid #c4c4c4;
  background: #c4c4c4;
  border-radius: 100%;
  box-sizing: border-box;
  &.active {
    border: 2px solid #2b2c32;
    background: #2b2c32;
  }
`;

export const PausePlayBtn = styled.button`
  height: 12.5px;
  width: 12.5px;
  color: #c4c4c4;

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    height: 15px;
    width: 15px;
  }

  span {
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }
`;
